import React from 'react';
import PropTypes from 'prop-types';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';


import DropZone from 'components/Shared/DropZone';
import LoadingButton from 'components/Shared/LoadingButton';



const AddQuestionDialog = ({ open, onClickCancel, onClickSave, onChange, reclamationId, text, isAdding, sauvegardable }) => (
    <Dialog
        fullWidth
        maxWidth={'md'}
        open={open}>
        <DialogTitle>
            Poser une question à l'émetteur du dossier après-vente {reclamationId}
        </DialogTitle>

        <DialogContent>

            <Stack spacing={1} pt={1}>

                <TextField
                    id="text"
                    name="text"
                    label="Question"
                    placeholder="Question"
                    multiline
                    value={text}
                    onChange={onChange}
                    autoFocus
                    disabled={isAdding}
                />

                <DropZone id="fichiersIds" name="fichiersIds" onChange={onChange} />

            </Stack>
        </DialogContent>

        <DialogActions>
            <Button onClick={onClickCancel} disabled={isAdding} color="primary" >Annuler</Button>
            <LoadingButton
                disabled={!sauvegardable || isAdding}
                onClick={onClickSave}
                label="Enregistrer"
                pending={isAdding}
            />
        </DialogActions>
    </Dialog>
);

AddQuestionDialog.propTypes = {
    onClickCancel: PropTypes.func.isRequired,
    onClickSave: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    reclamationId: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
    sauvegardable: PropTypes.bool.isRequired,
    isAdding: PropTypes.bool.isRequired
};

export default AddQuestionDialog;